import React from "react";
import { PrayerTableProps } from "../../types";
import { PrayerTableHeader } from "./PrayerTableHeader";
import { PrayerTableRow } from "./PrayerTableRow";

export const PrayerTable = React.memo(({
  prayers,
  show,
  isToday,
  HijraLocale,
  hijraLocale,
  renderCell,
  mainHeaders,
  subHeaders,
  firstRowBg,
  firstRowText,
  secondRowBg,
  secondRowText,
  highlightRow,
  translatedPrayerNames,
  monthMethod
}: PrayerTableProps) => (
  <table className="w-full">
    {highlightRow && (
      <thead>
        <tr className="demo-table-highlight">
          {highlightRow}
        </tr>
      </thead>
    )}
    <thead>
      {show ? (
        <PrayerTableHeader
          headers={mainHeaders}
          backgroundColor={secondRowBg}
          color={secondRowText}
          renderCell={renderCell}
          headerKey="main-header"
        />
      ) : (
        <>
          <tr style={{
            backgroundColor: firstRowBg,
            color: firstRowText,
          }}>
            <th></th>
            {translatedPrayerNames.map((prayer, i) => (
              <th
                key={i}
                colSpan={i === 0 ? 3 : 2}
                className="text-center"
              >
                {prayer}
              </th>
            ))}
          </tr>
          <PrayerTableHeader
            headers={subHeaders}
            backgroundColor={secondRowBg}
            color={secondRowText}
            renderCell={renderCell}
            headerKey="sub-header"
          />
        </>
      )}
    </thead>
    <tbody>
      {prayers.map((prayer, i) => (
        <PrayerTableRow
          key={i}
          prayer={prayer}
          HijraLocale={HijraLocale}
          hijraLocale={hijraLocale}
          show={show}
          renderCell={renderCell}
          index={i}
          isToday={isToday(prayer.date)}
        />
      ))}
    </tbody>
  </table>
));